import React from "react";
import './Line.css'
export default function Line({ width }) {
    return (
        <div className="line__container" style={{ width: width ? width : "80%" }}></div>
    )
}